/**
 * Copy text to the clipboard, falling back to the legacy `execCommand` textarea
 * trick in non-secure contexts. Rejects when neither path works, so callers can
 * surface an error instead of silently claiming success.
 */
export const copyTextToClipboard = async (text: string): Promise<void> => {
	try {
		await navigator.clipboard.writeText(text)
		return
	} catch {
		// Clipboard API unavailable or permission denied — try the legacy path.
	}

	const el = document.createElement('textarea')
	el.value = text
	document.body.appendChild(el)
	el.select()
	try {
		if (!document.execCommand('copy')) {
			throw new Error('execCommand("copy") refused to copy')
		}
	} finally {
		document.body.removeChild(el)
	}
}
